// Module
var code = "<div style=margin-left:-15px;margin-right:-15px> <nlg-script-sql-query-report sql-base-url={{ctrl.baseUrl}} domain={{ctrl.domain}} filter-service=ctrl.filterService sql-filter-service-url={{ctrl.filterServiceUrl}}> </nlg-script-sql-query-report> </div>";
// Exports
module.exports = code;